<template>
  <div>
    <div v-for="(item) in arrayList" :key="item.com_sequence_number" class="comment-container"
>
      <div class="comment-header">
        <div class="comment-info">
          <span class="pr-5">{{ item.name }}</span> 
          <span >{{ item.date }}</span>
          <v-chip v-if="item.cmType=='H'" color="secondary" class="mx-2 py-2 " rounded x-small label> <v-icon class="px-1" x-small>mdi mdi-stop-circle-outline</v-icon>Hold Comments</v-chip>
          <v-chip v-if="item.cmType=='SH'" color="error" class="mx-2 py-2 " rounded x-small label> <v-icon class="px-1" x-small>mdi-truck-alert-outline</v-icon>Shipment Hold Comments</v-chip>
          <v-chip v-if="item.cmType=='C'" color="error" class="mx-2 py-2 " rounded x-small label> <v-icon x-small class="px-1"> mdi mdi-cancel</v-icon>Cancel Comments</v-chip>
        </div>
        <div class="comment-actions">
          <v-btn v-if="item.showEdit" @click="editComment(item.com_sequence_number)" class="edit-btn" dense x-small outlined
            color="primary" title="Edit">
            <v-icon x-small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="item.showDelete" @click="deleteComment(item.com_sequence_number)" class="delete-btn" dense x-small
            outlined color="error" title="Delete">
            <v-icon x-small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="comment-body pb-4">

        {{ item.comments }}
      </div>
      <div class="comment-footer">
        <v-divider></v-divider>
        </div>
     
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'commentsDisplayComp',
  props: {
    arrayList: Array,
  },
  data() {
    return {

    }
  },

  created() {
  },
  mounted() {
  },

  methods: {
    editComment(com_sequence_number) {
      this.$emit("editComment", com_sequence_number)
    },
    deleteComment(com_sequence_number) {
      this.$emit("deleteComment", com_sequence_number)
    },
  },

}
</script>

<style>
.comment-container {
  margin-bottom: 10px;

}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  color: var(--v-secondary-base);
}

.comment-info {
  font-size: 15px;
  font-weight: bold;
  color: var(--v-primarytext);
  /* Set font color to black */
}

.comment-name {
  margin-right: 10px;
}



.comment-body {
  font-size: 15px;
  
  color: var(--v-primarytext);
  margin:0 5px;
  
}

.comment-date {
  font-size: 14px;
  color: black;
}

.comment-actions {
  display: flex;
  gap: 5px;
}

.edit-btn,
.delete-btn {
  padding: 0;
  min-width: 30px;
}



.secondaryBorder {
  border-color:var(--v-secondary-base) ;
}

.cancelBorder {
  border-color: red;
}
</style>
